export default __webpack_public_path__ + "static/solaris-signet-e6f33da6ebaffa690232d6cc1f63ee39.svg";